export function SVG_ShiftRect(r, svgElement) {
  var dx = svgElement["dx"];
  var dy = svgElement["dy"];

  if (dx != null && dy != null) r.Shift(dx, dy);
}
